// 全ユーザー共通メニュー定義
export const sideMenuConfig = [
  {
    title: 'File management',
    icon: 'mdi-file-document-edit-outline',
    children: [
      { label: 'ファイルアップロード画面', route: '/file/upload', name: 'UploadFileScreen' },
      { label: 'データ検索画面', route: '/file/download', name: 'DownloadFileScreen' }
    ]
  }
];
// 営業管理者用メニュー定義
export const sideMenuConfigSalesManager = [
// 20230919 奈良事務機向けコメントアウト
//  {
//    title: '管理者メニュー',
//    icon: 'mdi-file-document-edit-outline',
//    children: [
////      { label: 'データエクスポート', route: '/dataexport/output', name: 'DataExportOutput' },
//      { label: '売粗（組織）エクスポート', route: '/dataexport/selling/organization', name: 'DataExportSellingOrganization' },
//      { label: '売粗（担当）エクスポート', route: '/dataexport/selling/representative', name: 'DataExportSellingRepresentative' }
//    ]
//  }
];
// ユーザー管理者用メニュー定義
export const sideMenuConfigUserAdmin = [

];
// システム管理者用メニュー定義
export const sideMenuConfigAdmin = [

];

export interface MenuObject {
  title: string;
  icon: string;
  children: Array<ChildParam>;
}

interface ChildParam {
  label: string;
  route?: string;
}
